enum LeftNavRoutesEnumCommon {
  SETTINGS_USERS = '/settings/users',
  SETTINGS_ROLES = '/settings/roles',
  SETTINGS_PRIVILEGES = '/settings/privileges',
  SETTINGS_COMMISSIONS = '/settings/commissions',
  SETTINGS_DYNAMIC_PRICING = '/settings/dynamic-pricing',
}

enum LeftNavMenuKeysEnumCommon {
  SETTINGS = '/settings',
}

export { LeftNavRoutesEnumCommon, LeftNavMenuKeysEnumCommon };
